// TODO: remove this later when proper cloud apps are supported
export const NON_QUEUE_CLOUD_APP_PACKAGE_NAMES = ['web-signals'];

export default {
  NON_QUEUE_CLOUD_APP_PACKAGE_NAMES,
};
